import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { TShipmentsApi } from './types';

export const shipments: TShipmentsApi = {
	getIsSwissPostIntegrationEnabled: () =>
		http.get(endpoint.swissPost.GET_STATUS).then((response) => response.data),
	getSwissPostOrders: (payload) =>
		http.post(endpoint.swissPost.GET_ORDERS, payload).then((response) => response.data),
	getSwissPostOrder: (payload) =>
		http
			.post(endpoint.swissPost.GET_ORDER(payload.orderId), payload)
			.then((response) => response.data),
	downloadShipmentsLabel: (payload) =>
		http
			.post(endpoint.swissPost.DOWNLOAD_LABEL(payload.orderId), null, {
				responseType: 'blob',
			})
			.then((response) => response.data),
	downloadShipmentsProforma: (payload) =>
		http
			.post(endpoint.swissPost.DOWNLOAD_PROFORMA_INVOICE(payload.orderId), null, {
				responseType: 'blob',
			})
			.then((response) => response.data),
	requestSwissPostDelivery: (payload) =>
		http.post(endpoint.swissPost.REQUEST_DELIVERY(payload.orderId), payload),
	sendSwissPostLastErrorByEmail: (payload) =>
		http.post(endpoint.swissPost.SEND_LAST_ERROR_BY_EMAIL(payload.orderId), null),
	updateSwissPostHsCode: (payload) =>
		http.post(endpoint.swissPost.UPDATE_HS6_CODE(payload.orderId), {
			hS6Code: payload.hS6Code,
			productId: payload.productId,
		}),
	getHsCodeDescription: (params) =>
		http.get(endpoint.swissPost.HS_CODE_DESCRIPTION, { params }).then((response) => response.data),
	updateOrderFieldValues: (payload) =>
		http.post(endpoint.swissPost.UPDATE_ORDER_FIELD_VALUE(payload.orderId), {
			fieldValues: payload.fieldValues,
		}),
	updateCustomsDescriptions: (payload) =>
		http.post(endpoint.swissPost.UPDATE_CUSTOMS_DESCRIPTION(payload.orderId), {
			productId: payload.productId,
			customsDescriptions: payload.customsDescriptions,
		}),
	updateSwissPostWeight: (payload) =>
		http.put(endpoint.swissPost.UPDATE_WEIGHT(payload.orderId), {
			productId: payload.productId,
			weightInKg: payload.weightInKg,
		}),
	getSwissPostSignedProformaPreview: (payload) =>
		http
			.post(endpoint.swissPost.SIGNED_PROFORMA_INVOICE_PREVIEW(payload.orderId), payload.file, {
				responseType: 'blob',
			})
			.then((response) => response.data),
	uploadSwissPostProforma: (payload) =>
		http.post(endpoint.swissPost.UPLOAD_PROFORMA_INVOICE(payload.orderId), payload.file),
	getFirstMileLabel: (payload) =>
		http
			.post(endpoint.swissPost.FIRST_MILE_LABEL(payload.orderId), null, {
				responseType: 'blob',
			})
			.then((response) => response.data),
};
